import { gate } from 'hub-http/gates';
import { userInfoSync } from 'hub-http/userInfo';
import { useMemo } from 'react';
export const GATE_DEFINITIONS = {
  breezeAssistant: gate('Marketplace::Storefront::BreezeAssistant'),
  newDashboard: gate('Marketplace::Storefront::NewDashboard'),
  solutionsSpringSpotlight: gate('Marketplace::Solutions::SpringSpotlight'),
  tabularSearch: gate('Marketplace::Storefront::TabularSearch'),
  techPartnerTier: gate('Marketplace::Apps::TechPartnerTier'),
  workflowTemplatesPhase1: gate('Marketplace::WorkflowTemplates::Phase1')
};
function getGates() {
  try {
    return userInfoSync().gates;
  } catch (_unused) {
    return [];
  }
}
export function useGates() {
  const gates = getGates();
  return useMemo(() => Object.assign({}, Object.fromEntries(Object.entries(GATE_DEFINITIONS).filter(([k]) => k !== 'solutionsSpringSpotlight').map(([k, g]) => [k, gates.includes(g)])), {
    solutionsSpringSpotlight: true
  }), [gates]);
}